<input
	#dateInput
	class="form-control"
	id="{{ id }}"
	[autocomplete]="autocomplete"
	[disabled]="disabled"
	[max]="getMaxDate()"
	[min]="getMinDate()"
	[ngModelOptions]="{ standalone: true }"
	[placeholder]="'mm/dd/yyyy'"
	[type]="inputType"
	[(ngModel)]="formattedModel"
	(blur)="blur()"
	(dblclick)="changeInputType('text')"
	(keydown.enter)="dateInput.blur()"
	(ngModelChange)="onFormattedChange($event)"
/>
